<ng-container *ngIf="isLoading">
    <app-loading-page [showLabel]="true"></app-loading-page>
</ng-container>
<ng-container *ngIf="!isLoading">
    <router-outlet></router-outlet>
</ng-container>
